import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";

@Component({
  selector: "kreform-field-ion-html",
  template: ` <div  [ngStyle]="{
    color: fontProperty.color,
    'font-size': fontProperty.fontSize + 'px',
    'font-style': fontProperty.fontStyle ? 'italic' : 'normal',
    'font-weight': fontProperty.fontWeight ? 'bold' : 'normal'
  }" [innerHtml]="to.description | safeHtml"></div>`,
})
// 添加管道/指令/service  todo
export class KreFormFieldIonHtml extends FieldType {}
